/* eslint-disable */
import consumer from "./consumer"
import pako from "pako"

// Solo suscribirse si estamos en una página de tema
const temaElement = document.querySelector('.core-ThreadPostsList');

if (temaElement) {
  // Extraer el ID del tema del data attribute
  const temaId = temaElement.dataset.temaId;

  if (temaId) {
    consumer.subscriptions.create(
      { channel: "RankitoChannel", tema_id: temaId },
      {
        connected() {
          // Mostrar indicador si el usuario acaba de mencionar a Rankito
          this.mostrarIndicadorSiCorresponde()
        },

        disconnected() {
          this.ocultarIndicadorEspera()
        },

        received(data) {
          if (data.tipo === 'nueva_respuesta_comprimida') {
            this.mostrarNuevaRespuesta(data)
          } else if (data.tipo === 'nueva_respuesta_fallback') {
            this.mostrarNuevaRespuestaFallback(data)
          }
        },

        mostrarNuevaRespuesta(data) {
          // Ocultar indicador de espera si estaba activo
          this.ocultarIndicadorEspera()

          // Descomprimir HTML usando pako
          const html = this.descomprimirHtml(data.html_comprimido, data.contenido_link)

          // Buscar dónde insertar la nueva respuesta
          const parentElement = document.querySelector(`#respuesta_${data.parent_id}`)

          if (parentElement) {
            // Insertar después del elemento padre
            parentElement.insertAdjacentHTML('afterend', html)

            // Scroll suave hacia la nueva respuesta
            const nuevaRespuesta = document.querySelector(`#respuesta_${data.respuesta_id}`)
            if (nuevaRespuesta) {
              nuevaRespuesta.scrollIntoView({ behavior: 'smooth', block: 'nearest' })

              // Efecto visual temporal
              nuevaRespuesta.classList.add('nueva-respuesta-rankito')
              setTimeout(() => {
                nuevaRespuesta.classList.remove('nueva-respuesta-rankito')
              }, 3000)
            }
          }
        },

        mostrarNuevaRespuestaFallback(data) {
          // Ocultar indicador de espera si estaba activo
          this.ocultarIndicadorEspera()

          // Mostrar notificación con enlace directo (payload demasiado grande para Action Cable)
          const html = `
            <div class="rnk-Flash-info rnk-margin-medium nueva-respuesta-rankito">
              <strong>Rankito</strong> ya ha publicado su respuesta.
              <button type="button" class="rnk-Link" style="background: none; border: none; padding: 0; text-decoration: underline; cursor: pointer; color: inherit;" onclick="window.open('${data.contenido_link}', '_blank');">Haz clic aquí para verla</button>
            </div>
          `

          // Buscar dónde insertar la notificación
          const parentElement = document.querySelector(`#respuesta_${data.parent_id}`)

          if (parentElement) {
            // Insertar después del elemento padre
            parentElement.insertAdjacentHTML('afterend', html)

            // Scroll suave hacia la notificación
            const notificacion = parentElement.nextElementSibling
            if (notificacion) {
              notificacion.scrollIntoView({ behavior: 'smooth', block: 'nearest' })

              // Remover efecto visual después de un tiempo
              setTimeout(() => {
                notificacion.classList.remove('nueva-respuesta-rankito')
              }, 3000)
            }
          }
        },

        mostrarIndicadorSiCorresponde() {
          // Mostrar indicador solo si se detecta que acabamos de enviar una mención a Rankito
          if (this.usuarioAcabaDeMencionarRankito()) {
            this.mostrarIndicadorEspera()
          }
        },

        usuarioAcabaDeMencionarRankito() {
          // Verificar si hay un parámetro en la URL que indique que se mencionó a Rankito
          const urlParams = new URLSearchParams(window.location.search)
          const mencionoRankito = urlParams.get('rankito_mentioned') === 'true'

          // También verificar localStorage para casos de redirección (más confiable)
          const rankitoMencionado = localStorage.getItem('rankito_mentioned') === 'true'

          if (rankitoMencionado) {
            // Limpiar la flag después de usarla
            localStorage.removeItem('rankito_mentioned')
          }

          return mencionoRankito || rankitoMencionado
        },        mostrarIndicadorEspera() {
          // Evitar duplicados
          if (document.getElementById('rankito-thinking-indicator')) {
            return
          }

          // Crear indicador de que Rankito está pensando
          const indicador = document.createElement('div')
          indicador.id = 'rankito-thinking-indicator'
          indicador.className = 'rankito-thinking-indicator'
          indicador.innerHTML = `
            <div style="display: flex; align-items: center; justify-content: center;">
              <div class="rnk-spinner"></div>
              <span class="rankito-thinking-text">Rankito está preparando una respuesta...</span>
            </div>
          `

          // Buscar la última respuesta visible para insertar el spinner justo después
          const ultimaRespuesta = temaElement.querySelector('[id^="respuesta_"]:last-of-type')

          // Siempre habrá respuestas porque Rankito solo interviene cuando lo mencionan/responden
          ultimaRespuesta.insertAdjacentElement('afterend', indicador)

          // Scroll suave hacia el indicador
          indicador.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        },

        ocultarIndicadorEspera() {
          const indicador = document.getElementById('rankito-thinking-indicator')
          if (indicador) {
            indicador.remove()
          }
        },

        descomprimirHtml(encodedCompressedHtml, contenidoLink) {
          try {
            // Decodificar Base64
            const binaryString = atob(encodedCompressedHtml)
            const compressedBytes = new Uint8Array(binaryString.length)
            for (let i = 0; i < binaryString.length; i++) {
              compressedBytes[i] = binaryString.charCodeAt(i)
            }

            // Descomprimir usando pako
            const decompressedBytes = pako.inflate(compressedBytes)

            // Convertir bytes de vuelta a string
            return new TextDecoder('utf-8').decode(decompressedBytes)
          } catch (error) {
            console.error('Error descomprimiendo HTML:', error)

            // Fallback con botón (inmune a interceptación de hotwired.js)
            if (contenidoLink) {
              return `
                <div class="rnk-Flash-info rnk-margin-medium">
                  <strong>Rankito</strong> ya ha publicado su respuesta.
                  <button type="button" class="rnk-Link" style="background: none; border: none; padding: 0; text-decoration: underline; cursor: pointer; color: inherit;" onclick="window.open('${contenidoLink}', '_blank');">Haz clic aquí para verla</button>
                </div>
              `
            }

            // Último recurso si no hay contenido_link
            return '<div class="rnk-Flash-error">Error cargando respuesta de Rankito</div>'
          }
        }
      }
    );
  }
}

export default { rankitoChannel: true }
